import {
  AttachMoney,
  CreditCard,
  DateRange,
  People,
  Place,
  PlaylistAddCheck,
  PieChart,
  AccountBalance,
  AccountBalanceWallet,
  TrendingUp,
  LocalShipping,
  LocalHospital,
  Hotel,
  Group,
  CardMembership
} from '@material-ui/icons';
import { useConstantsContext } from '../../context/constants_context';

export const dashboardData = [
  {
    id: 'membership',
    title: 'Membership Dashboard',
    value: '0',
    trend: 'up',
    trendValue: '+8.6%',
    icon: CardMembership,
    image: '/assets/images/membership-dashboard.jpg',
    children: [
      {
        id: 'mem-active',
        title: 'Active Members',
        value: '11,234',
        trend: 'up',
        trendValue: '+6.2%',
        icon: People
      },
      {
        id: 'mem-new',
        title: 'Movement Summary',
        value: '1,613',
        trend: 'up',
        trendValue: '+18.4%',
        icon: Group
      },
      {
        id: 'mem-retention',
        title: 'Contributions',
        value: '91.3%',
        trend: 'up',
        trendValue: '+2.1%',
        icon: PlaylistAddCheck
      },
      {
        id: 'mem-region',
        title: 'By Region',
        value: '10 Branches',
        trend: 'up',
        trendValue: '+0 new',
        icon: Place
      }
    ]
  },
  {
    id: 'insurance',
    title: 'Provident Dashboard',
    value: '0',
    trend: 'up',
    trendValue: '+5.7%',
    icon: LocalHospital,
    image: '/assets/images/insurance-dashboard.jpg',
    children: [
      {
        id: 'ins-premiums',
        title: 'Claims Statistics',
        value: 'Reports',
        trend: 'up',
        trendValue: '+7.3%',
        icon: AccountBalanceWallet
      },
      {
        id: 'ins-claims',
        title: 'Claims Paid',
        value: 'Charts',
        trend: 'down',
        trendValue: '+11.2%',
        icon: AttachMoney
      },
      {
        id: 'ins-policies',
        title: 'Claims by Type',
        value: 'Reports',
        trend: 'up',
        trendValue: '+4.6%',
        icon: DateRange
      },
      {
        id: 'ins-ratio',
        title: 'Arcturial Report',
        value: 'Reports',
        trend: 'up',
        trendValue: '-2.3%',
        icon: PieChart
      }
    ]
  },
  {
    id: 'loans',
    title: 'Loans Dashboard',
    value: '0',
    trend: 'up',
    trendValue: '+12.4%',
    icon: AccountBalance,
    image: '/assets/images/loans-dashboard.jpg',
    children: [
      {
        id: 'loans-outstanding',
        title: 'Loan Book (USD)',
        value: '$0',
        trend: 'down',
        trendValue: '+3.2%',
        icon: CreditCard
      },
      // {
      //   id: 'loans-zim',
      //   title: 'Loan Book (ZWG)',
      //   value: '$0',
      //   trend: 'down',
      //   trendValue: '+3.2%',
      //   icon: CreditCard
      // },
      {
        id: 'loans-disbursed',
        title: 'Payable vs Paid',
        value: '$0',
        trend: 'up',
        trendValue: '+9.1%',
        icon: AttachMoney
      },
      {
        id: 'loans-repayment',
        title: 'NPV (Net Present Value)',
        value: '0%',
        trend: 'up',
        trendValue: '+1.8%',
        icon: TrendingUp
      },
      {
        id: 'loans-defaulted',
        title: 'NPV By Ledger Account',
        value: '0%',
        trend: 'down',
        trendValue: '+0.4%',
        icon: PieChart
      }
    ]
  },
  {
    id: 'hospitality',
    title: 'Ehlekwini Dashboard',
    value: '0',
    trend: 'up',
    trendValue: '+14.2%',
    icon: Hotel,
    image: '/assets/images/hospitality-dashboard.jpg',
    children: [
      {
        id: 'hosp-occupancy',
        title: 'Occupancy Rate',
        value: '78.4%',
        trend: 'up',
        trendValue: '+6.1%',
        icon: Hotel
      },
      {
        id: 'hosp-revenue',
        title: 'Room Revenue',
        value: '$2.4M',
        trend: 'up',
        trendValue: '+11.8%',
        icon: AttachMoney
      },
      {
        id: 'hosp-events',
        title: 'Stores Inventory',
        value: '142',
        trend: 'up',
        trendValue: '+22.4%',
        icon: DateRange
      },
      {
        id: 'hosp-satisfaction',
        title: 'Tuckshop Performance',
        value: '4.6/5',
        trend: 'up',
        trendValue: '+0.3',
        icon: LocalShipping
      }
    ]
  }
];

export const salesData = [
  {
    glMonth: 'April 2025',
    currency: 'USD',
    totalAmount: 12379.1176,
    resultDate: '2025-04-01T00:00:00'
  },
  {
    glMonth: 'May 2025',
    currency: 'USD',
    totalAmount: 11730.4151,
    resultDate: '2025-05-01T00:00:00'
  },
  {
    glMonth: 'June 2025',
    currency: 'USD',
    totalAmount: 9948.0486,
    resultDate: '2025-06-01T00:00:00'
  },
  {
    glMonth: 'July 2025',
    currency: 'USD',
    totalAmount: 8533.4472,
    resultDate: '2025-07-01T00:00:00'
  },
  {
    glMonth: 'August 2025',
    currency: 'USD',
    totalAmount: 6901.9652,
    resultDate: '2025-08-01T00:00:00'
  },
  {
    glMonth: 'September 2025',
    currency: 'USD',
    totalAmount: 5705.4139,
    resultDate: '2025-09-01T00:00:00'
  },
  {
    glMonth: 'October 2025',
    currency: 'USD',
    totalAmount: 4560.8414,
    resultDate: '2025-10-01T00:00:00'
  },
  {
    glMonth: 'November 2025',
    currency: 'USD',
    totalAmount: 3593.051,
    resultDate: '2025-11-01T00:00:00'
  },
  {
    glMonth: 'December 2025',
    currency: 'USD',
    totalAmount: 2903.4091,
    resultDate: '2025-12-01T00:00:00'
  },
  {
    glMonth: 'January 2026',
    currency: 'USD',
    totalAmount: 4246.4935,
    resultDate: '2026-01-01T00:00:00'
  },
  {
    glMonth: 'March 2026',
    currency: 'USD',
    totalAmount: 1759.7454,
    resultDate: '2026-03-01T00:00:00'
  },
  {
    glMonth: 'April 2026',
    currency: 'USD',
    totalAmount: 1613.3645,
    resultDate: '2026-04-01T00:00:00'
  }
];

export const npvData = [
  {
    country: 'ZIMTA',
    contract_No: 13,
    client_No: 137,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 1643.7948,
    cumulative_MY: 'September 2024',
    totalDebt: 1643.7948,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 1506.8148,
    currentBalance: 1506.8148,
    total_Paid: -136.98,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 1506.8148,
    no_Outstanding: 1,
    original_Outstanding: 1643.7948,
    debt_Paid: 136.98,
    val_Total_Outstanding: 1506.8148,
    loan_Value: 1000.0
  },
  {
    country: 'ZIMTA',
    contract_No: 23,
    client_No: 144,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 821.898,
    cumulative_MY: 'September 2024',
    totalDebt: 821.898,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 479.448,
    currentBalance: 479.448,
    total_Paid: -342.45,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 479.448,
    no_Outstanding: 1,
    original_Outstanding: 821.898,
    debt_Paid: 342.45,
    val_Total_Outstanding: 479.448,
    loan_Value: 500.0
  },
  {
    country: 'ZIMTA',
    contract_No: 26,
    client_No: 145,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 821.898,
    cumulative_MY: 'September 2024',
    totalDebt: 821.898,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 20.578,
    currentBalance: 20.578,
    total_Paid: -801.32,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 20.578,
    no_Outstanding: 1,
    original_Outstanding: 821.898,
    debt_Paid: 801.32,
    val_Total_Outstanding: 20.578,
    loan_Value: 500.0
  },
  {
    country: 'ZIMTA',
    contract_No: 28,
    client_No: 135,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 821.898,
    cumulative_MY: 'September 2024',
    totalDebt: 821.898,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 20.578,
    currentBalance: 20.578,
    total_Paid: -801.32,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 20.578,
    no_Outstanding: 1,
    original_Outstanding: 821.898,
    debt_Paid: 801.32,
    val_Total_Outstanding: 20.578,
    loan_Value: 500.0
  },
  {
    country: 'ZIMTA',
    contract_No: 53,
    client_No: 120,
    product: '6 Month Loan',
    term: 6,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 1058.0988,
    cumulative_MY: 'September 2024',
    totalDebt: 1058.0988,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 1058.0988,
    currentBalance: 1058.0988,
    total_Paid: 0.0,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 1058.0988,
    no_Outstanding: 1,
    original_Outstanding: 1058.0988,
    debt_Paid: 0.0,
    val_Total_Outstanding: 1058.0988,
    loan_Value: 800.0
  },
  {
    country: 'ZIMTA',
    contract_No: 60,
    client_No: 191,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 1643.7948,
    cumulative_MY: 'September 2024',
    totalDebt: 1643.7948,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 394.9719,
    currentBalance: 485.5198,
    total_Paid: -1111.84,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 485.5198,
    no_Outstanding: 1,
    original_Outstanding: 1643.7948,
    debt_Paid: 1111.84,
    val_Total_Outstanding: 531.9548,
    loan_Value: 1000.0
  },
  {
    country: 'ZIMTA',
    contract_No: 61,
    client_No: 190,
    product: '12 Month Loan',
    term: 12,
    branch: 'HeadOffice',
    employer_Group: 'Ministry of Education',
    disb_Date: '2024-09-13T00:00:00',
    disb_Date_MY: 'September 2024',
    year: null,
    number: null,
    value: null,
    number_Month: null,
    value_Month: null,
    reportMonth: 'Other',
    tot_Repayable: 1150.6572,
    cumulative_MY: 'September 2024',
    totalDebt: 1150.6572,
    status: 'Active',
    sub_Status: 'Arrears',
    arrears: 1054.7672,
    currentBalance: 1054.7672,
    total_Paid: -95.89,
    no_Closed: 0,
    npV_Closed: 0.0,
    npV_Active: 1054.7672,
    no_Outstanding: 1,
    original_Outstanding: 1150.6572,
    debt_Paid: 95.89,
    val_Total_Outstanding: 1054.7672,
    loan_Value: 700.0
  }
];
